import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  updateExistingProducts: {
    defaultMessage: 'Overwrite existing values for all fields included in the CSV',
    id: 'ufnzJT',
    description: 'Option to update existing products',
  },
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to your product records. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'vaaQvx',
    description: 'Product Import help content text',
  },
  uploadFile: {
    id: '8cjYM6',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the import process',
  },
  fulfillmentBarcodeWarningMessage: {
    defaultMessage: 'Modifying barcodes for products already labeled in Fulfilled by ShipStation warehouses may cause delays.',
    id: '31Q7oY',
    description: 'Warning message for fulfillment barcode field',
  },
});
